// Libs
import { TFunction } from 'i18next';
// Others
import { ReportIconSaleByCity, ReportIconTechnician } from '~/assets/svgComponents';
import { ReportItemEnum } from '~/utils/enum/common';
import { IReportItem } from '~/utils/interface/report';

//#region Report
export const reportList = (t: TFunction): IReportItem[] => [
  {
    icon: ReportIconTechnician,
    title: t('report_page_item_title_technician'),
    desc: t('report_page_item_desc_technician'),
    type: ReportItemEnum.TECHNICIAN_PERFORMANCE,
  },
  {
    icon: ReportIconSaleByCity,
    title: t('report_page_item_title_sale_by_city'),
    desc: t('report_page_item_desc_sale_by_city'),
    type: ReportItemEnum.SALE_BY_CITY,
  },
  {
    icon: ReportIconTechnician,
    title: t('report_page_item_title_service_volume'),
    desc: t('report_page_item_desc_service_volume'),
    type: ReportItemEnum.SERVICE_VOLUME,
  },
  {
    icon: ReportIconTechnician,
    title: t('report_page_item_title_per_call_average'),
    desc: t('report_page_item_desc_per_call_average'),
    type: ReportItemEnum.PER_CALL_AVERAGE,
  },
  {
    icon: ReportIconSaleByCity,
    title: t('report_page_item_title_po_per_pay_period'),
    desc: t('report_page_item_desc_po_per_pay_period'),
    type: ReportItemEnum.PO_PER_PAY_PERIOD,
  },
];
//#endregion Setting
